/* eslint-disable import/no-extraneous-dependencies */
import { sendVerificationCode, authorizeUser } from "services/firebase";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "components/Common/button";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Text from "components/Common/Text";
import { object, string } from "yup";

import { normalizePhoneNumber } from "../../utils/index";

const phoneRegExp =
  /\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}/g;

const validationSchema = object().shape({
  phoneNumber: string()
    .matches(phoneRegExp, "Phone number is not valid")
    .required(),
});

// eslint-disable-next-line react/prop-types
function AuthForm() {
  const [verificationId, setVerificationId] = useState(null);
  const [isSending, setIsSending] = useState(false);
  const [timer, setTimer] = useState(0);

  const [locding, setLoading] = useState(false);

  const {
    handleSubmit,
    formState: { errors },
    setError,
    setFocus,
    setValue,
    register,
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    setFocus("confirmationCode");
  }, [setFocus, verificationId]);

  const onSubmit = async (data) => {
    setLoading(true);
    const normalizedPhoneNumber = normalizePhoneNumber(data.phoneNumber);
    if (!verificationId) {
      try {
        const result = await sendVerificationCode(normalizedPhoneNumber);
        setVerificationId(result?.verificationId);
        setLoading(false);
      } catch (e) {
        setError("phoneNumber", {
          type: "custom",
          message: e.message,
        });
        setLoading(false);
      }
    }
    if (verificationId) {
      try {
        await authorizeUser(verificationId, data.confirmationCode);
        // window.location.reload();
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setError("confirmationCode", {
          type: "custom",
          message: "Code is incorrect",
        });
      }
    }
  };

  useEffect(() => {
    let intervalId;
    if (timer > 0 && isSending) {
      intervalId = setInterval(() => {
        setTimer(timer - 1);
      }, 1000);
    } else if (timer === 0 && isSending) {
      setIsSending(false);
    }

    return () => clearInterval(intervalId);
  }, [isSending, timer]);

  const sendAgainSms = () => {
    setIsSending(true);
    setValue("confirmationCode", null);
    setTimer(10); // Set the timer to 60 seconds
    onSubmit();
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Text as="H4" ta="center" mt={32}>
          Enter your mobile number
        </Text>
        <input
          {...register("phoneNumber", {
            pattern: {
              value:
                /\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}/g,
              message: "invalid phone format",
            },
          })}
          placeholder="+1 (234) 567-8901"
          type="tel"
          style={{
            height: 52,
            width: "100%",
            minWidth: 329,
            borderRadius: 16,
            marginTop: 8,
            paddingLeft: 10,
          }}
        />
        <Text as="C2" mt={10} style={{ margin: "10px 16px" }}>
          By signing up for CCMGG you agree to the Terms & Conditions.
        </Text>

        {verificationId && (
          <div style={{ position: "relative", marginBottom: 10 }}>
            <input
              {...register("confirmationCode")}
              placeholder="Confirmation Code"
              style={{
                height: 52,
                width: "100%",
                minWidth: 329,
                borderRadius: 16,
                marginTop: 8,
                paddingLeft: 10,
                border: errors.confirmationCode && "2px solid #ff375f",
              }}
            />

            <button
              onClick={sendAgainSms}
              disabled={isSending}
              type="button"
              style={{
                backgroundColor: "transparent",
                position: "absolute",
                right: 16,
                top: 8,
                height: 52,
                display: "flex",
                alignItems: "center",
              }}
            >
              {isSending ? (
                <Text as="C1" style={{ color: "#379FDC" }}>
                  Sending... {timer}s
                </Text>
              ) : (
                <Text as="C1" style={{ color: "#379FDC" }}>
                  Send Again
                </Text>
              )}
            </button>
          </div>
        )}

        {errors.confirmationCode && (
          <Text as="C1" ta="center">
            {errors.confirmationCode.message}
          </Text>
        )}
        <Button
          title={!verificationId ? "NEXT" : "Lets GO"}
          style={{ width: "100%", marginTop: 10 }}
          onPress={handleSubmit(onSubmit)}
          type="submit"
          blocked={locding}
        />
      </form>
    </div>
  );
}

export default AuthForm;
